export default __webpack_public_path__ + "static/media/fpa40030.c01b5fae.png";